import dayjs from "dayjs";

export const isTaskDueDateAcceptable = (dueDate, now = dayjs()) => {
  if (dueDate == null) return false;
  const parsed = dayjs(dueDate);
  if (!parsed.isValid()) return false;
  return !parsed.isBefore(now);
};
